import { get } from 'lodash';
import { exceedRetentionPeriod } from '@hooks/eco/useECOQueryError';

const UNKNOWN_ERROR = 'Something went wrong. Please try again';

export const getErrorConfig = (error: any) => {
  const message = get(error, 'response.data.message', UNKNOWN_ERROR);

  return {
    retry: exceedRetentionPeriod(error) ? false : true,
    message: message,
  };
};
